import ObjectFit from 'gi-feature-object-fit'
import Gallery from '../src'

base.features.add('fit', ObjectFit)

base.features.add('gallery', Gallery, {

})

base.features.init()



// WEBPACK FOOTER //
// ./docs/demo.js